import { Block } from '@contentful/rich-text-types'
import React from 'react'
import cn from 'classnames'
import styles from './rich-text.module.scss'
interface UlListProps extends Block {
  children?: React.ReactNode
}

export const UlList: React.FC<UlListProps> = (props) => {
  return <ul className={cn(styles.list, styles.ulList)}>{props.children}</ul>
}
